/* eslint-disable jira/filename-case */

import { v4 as uuid } from 'uuid';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, type Store } from '@atlassian/react-sweet-state';
import * as actions from './actions/index.tsx';
import type { Actions } from './actions/page-events/index.tsx';
import type { State } from './types.tsx';

export const initialState: State = {
	transitionCheckTimestamp: -1,
	currentPage: {
		uuid: __SERVER__ ? '' : uuid(),
		startTime:
			(typeof performance !== 'undefined' &&
				performance.timing !== undefined &&
				// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
				performance.timing.navigationStart) ||
			0,
		apps: {},
		userLocation: '',
	},
	visitedPages: [],
	navigation: {
		isCollapsed: false,
		viewId: 'noView',
		viewType: '',
		projectType: null,
		isInitialEventSent: false,
		pageId: null,
		nextViewId: '',
	},
};

const store: Store<State, Actions> = createStore<State, Actions>({
	name: 'spa-state',
	initialState,
	actions,
});

export default store;
